import PeopleIcon from '@mui/icons-material/People';
import SecurityIcon from '@mui/icons-material/Security';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import type { NavigationItem, ModuleInfo } from '@core/router/types';
import { Permissions } from '@core/auth/permissions';

/**
 * Users Module Information
 *
 * Used by the ModuleSelector to display and navigate to this module.
 * Only visible to users with Users.Users.Read permission (SystemAdmin, UserAdmin).
 */
export const usersModuleInfo: ModuleInfo = {
  id: 'korisnici',
  labelKey: 'modules.users.name',
  icon: <PeopleIcon />,
  basePath: '/korisnici',
  accessPermission: Permissions.Users.Users.Read, // Base Users permission
  order: 2,
};

/**
 * Users Module Navigation Items
 *
 * Defines the sidebar navigation structure for the Users module.
 * This module is for user management, role assignment, and permission management.
 * 
 * Only visible to:
 * - SystemAdmin (full access)
 * - UserAdmin (user management only)
 */
export const usersNavigation: NavigationItem[] = [
  {
    label: 'Korisnici',
    labelKey: 'users.nav.users',
    path: '/korisnici/lista',
    icon: <PeopleIcon />,
    permission: Permissions.Users.Users.Read,
  },
  {
    label: 'Uloge',
    labelKey: 'users.nav.roles',
    path: '/korisnici/uloge',
    icon: <SecurityIcon />,
    permission: Permissions.Users.Roles.Read,
  },
  {
    label: 'Permisije',
    labelKey: 'users.nav.permissions',
    path: '/korisnici/permisije',
    icon: <VpnKeyIcon />,
    permission: Permissions.Users.Permissions.Assign,
  },
];

